const { InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow, ToggleControl, SelectControl } = wp.components;

import ImageControl from '../wp-controlers/mediaUpload';
import CommonPanel from '../wp-controlers/common-panel';
import SelectColor from '../wp-controlers/select-color';
import SelectAlign from '../wp-controlers/select-align';

const Inspector = ({ attributes, setAttributes }) => {
  const { hasIcon, iconPosition, variant } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Atributos do tópico" initialOpen={true}>
        <SelectControl
          label="Selecione o estilo desejado"
          title="Selecione o estilo desejado"
          value={variant}
          options={[
            { label: 'Com descrição', value: 'default' },
            { label: 'Apenas Titulo', value: 'just-title' },
            { label: 'Imagem com descrição', value: 'image-description' },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />

        <SelectColor attributes={attributes} setAttributes={setAttributes} />
        <SelectAlign attributes={attributes} setAttributes={setAttributes} />

        <ToggleControl
          label="Adicionar icone ao título "
          checked={hasIcon}
          onChange={() => setAttributes({ hasIcon: !hasIcon })}
        />

        {variant === 'image-description' && (
          <ImageControl
            label="Imagem"
            image="image"
            attributes={attributes}
            setAttributes={setAttributes}
          />
        )}
      </PanelBody>

      {hasIcon && (
        <PanelBody title="Atributos do icone" initialOpen={true}>
          <ImageControl
            label="Icone do tópico"
            image="icon"
            attributes={attributes}
            setAttributes={setAttributes}
          />

          <SelectControl
            label="Selecione a posição do icone"
            title="Selecione a posição do icone"
            value={iconPosition}
            options={[
              { label: 'Topo', value: 'top' },
              { label: 'Meio', value: 'middle' },
              { label: 'Baixo', value: 'bottom' },
            ]}
            onChange={(position) => setAttributes({ iconPosition: position })}
          />
        </PanelBody>
      )}

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
